import axios from 'axios';
import { setAlert } from './alert';
import {
  GET_IME_ARTICLES,
  IME_ARTICLE_ERROR,
  UPDATE_IME_ARTICLE_LIKES,
  DELETE_IME_ARTICLE,
  ADD_IME_ARTICLE,
  GET_IME_ARTICLE,
  ADD_IME_ARTICLE_COMMENT,
  ADD_IME_ARTICLE_REPLY,
  REMOVE_IME_ARTICLE_COMMENT,
} from './types';

// Get articles
export const getIMEArticles = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/owner');

    dispatch({
      type: GET_IME_ARTICLES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get article
export const getIMEArticle = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/owner/${id}`);

    dispatch({
      type: GET_IME_ARTICLE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add article like
export const addIMEArticleLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/owner/like/${id}`);

    dispatch({
      type: UPDATE_IME_ARTICLE_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove article like
export const removeIMEArticleLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/owner/unlike/${id}`);

    dispatch({
      type: UPDATE_IME_ARTICLE_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add comment
export const addIMEArticleComment = (formData) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await axios.post(
      '/api/owner/imearticlecomment',
      formData,
      config
    );

    dispatch({
      type: ADD_IME_ARTICLE_COMMENT,
      payload: res.data,
    });

    dispatch(setAlert('Comment Added'));
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add reply to article comment
export const addIMEArticleReply = (formData) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await axios.post(
      '/api/owner/imearticlecomment/imearticlereply',
      formData,
      config
    );

    dispatch({
      type: ADD_IME_ARTICLE_REPLY,
      payload: res.data,
    });

    dispatch(setAlert('Reply Added'));
  } catch (err) {
    dispatch({
      type: IME_ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
